<template><div><h1 id="kundenanzahl-entwicklung" tabindex="-1"><a class="header-anchor" href="#kundenanzahl-entwicklung"><span>Kundenanzahl-Entwicklung</span></a></h1>
<p>Kundenanzahl-Entwicklung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Textdatei (tabulatorgetrennt), welche die Entwicklung der Anzahl Kunden aufzeigt. Als Kunden gelten Adressen mit Status als Spender, Zusager und Käufer in einem bestimmten Jahr. Das Programm berücksichtigt also alle Umsätze aus Warenhandel, Spenden oder Zusagen. Es zeigt auch, welche Kunden in einem bestimmten, definierbaren Zeitraum inaktiv waren, d.h. keinen Umsatz verzeichneten. Ausserdem zeigt es, welche Kunden neu gewonnen werden konnten, und welche verloren gegangen sind sowie die Differenz (Zu- oder Abnahme). Pro Jahr des Auswertungszeitraums wird eine Zeile ausgegeben. Zur leichteren Übersicht können die Daten in einer Tabellenverarbeitung weiter bearbeitet werden.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Kundenanzahl-Entwicklung</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Jahr von</dt>
<dd>Muss-Eingabe: erstes Jahr der Auswertung (1. Spalte)</dd>
<dt>bis</dt>
<dd>Muss-Eingabe: letztes Jahr der Auswertung (1. Spalte)</dd>
<dt>inaktive Jahre</dt>
<dd>Anzahl Jahre, die eine Adresse keinen Umsatz gemacht haben muss, damit sie als &quot;verlorener Kunde&quot; (sog. Lapsed) gewertet wird (inklusive Auswertungsjahr)</dd>
<dt>Ausgabe</dt>
<dd>Textdatei tabulatorgetrennt</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Jahr</td>
<td>mögliche Werte siehe Parameter [Jahr von] und [bis]</td>
</tr>
<tr>
<td>gewonnen neu</td>
<td>Anzahl neu gewonnener Kunden</td>
</tr>
<tr>
<td>gewonnen Lapsed</td>
<td>Anzahl neu reaktivierter Kunden, die die letzten [inaktive Jahre] Jahre keinen Umsatz hatten (Lapsed).</td>
</tr>
<tr>
<td>gewonnen Total</td>
<td>Anzahl gewonnener Kunden: Summe aus Spalten 2 und 3</td>
</tr>
<tr>
<td>verloren Total</td>
<td>Anzahl verlorener Kunden, d.h. die, welche seit genau [inaktive Jahre] Jahren keinen Umsatz mehr haben.</td>
</tr>
<tr>
<td>Kundenstammänderung</td>
<td>Änderung der Kundenanzahl: Differenz zwischen Spalten 4 und 5</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Kundenanzahl-Entwicklung</span>
<span class="line">Jahr	gewonnen neu	gewonnen Lapsed	gewonnen Total	verloren Total	Kundenstammänderung</span>
<span class="line">1998	34065	28428	62493	78721	-16228</span>
<span class="line">1999	4506	3664	8170	72950	-64780</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


